import { useEffect } from "react";

import { isDemoMode, useSmokeballApp } from "@smart/itops-smokeball-app-dom";

declare global {
  interface Window {
    captureDemoMode?: () => void;
  }
}

const buildDemoConfig = async (
  smokeballApp: ReturnType<typeof useSmokeballApp>,
) => {
  const { auth, context, matters, contacts, staff } = smokeballApp;

  return {
    token: (await auth?.token()) || "",
    idToken: (await auth?.idToken()) || "",
    context: {
      region: context?.region ?? { code: "", name: "" },
      firmId: context?.firmId,
      userId: context?.userId,
      matterId: context?.matterId,
      matters: matters?.current ? [matters.current] : [],
      layoutMatters: [],
      relationships: [],
      roles: [],
      contacts: contacts?.current ?? [],
      staff: staff?.current ?? [],
    },
  };
};

/**
 * `window.captureDemoMode()` logs a JSON blob of the current
 * auth token + context, for pasting into the Demo Gate.
 */
const CaptureDemoMode = () => {
  const smokeballApp = useSmokeballApp();

  useEffect(() => {
    if (isDemoMode()) return undefined;

    window.captureDemoMode = () => {
      buildDemoConfig(smokeballApp)
        .then((config) => console.info(JSON.stringify(config, null, 2)))
        .catch((error) =>
          console.error("Failed to capture demo mode config.", error),
        );
    };

    return () => {
      delete window.captureDemoMode;
    };
  }, [smokeballApp]);

  return null;
};

export { CaptureDemoMode };
